import React, { Component } from 'react'

import First from '../block/First'
import Events from '../block/Events'
import Feedback from '../block/Feedback'
import Faq from '../block/Faq'

class App extends Component {

  render() {

    const data = this.props?.data

    return (
      <>
        <First
          bg={data?.first_bg}
          title={data?.first_title}
          text={data?.first_text}
          chipText={data?.first_chipText}
          button1Text={data?.first_button1Text}
          button2Text={data?.first_button2Text}
          scrollText={data?.first_scrollText}
          height={data?.first_height}
          plashka={data?.first_plashka}
          data={data}
        />
        <Events data={data} />
        <Feedback data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App